import axios from "axios";
import { useURL } from "../data/Config";
import { ITransaction } from "../types";

export interface IFinanceStats {
  yearlyFinance: {
    name: string;
    income: number;
    expense: number;
  }[];
  totalIncome: number;
  totalExpense: number;
}

export const getAllTransactionsByAdmin = async (
  searchQuery?: string
): Promise<ITransaction[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<ITransaction[]>(
    `${useURL}/transactions/admin/get-all-transactions`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );

  return response.data;
};
export const getFinanceStats = async (): Promise<IFinanceStats> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<IFinanceStats>(
    `${useURL}/transactions/finance-stats`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
